export enum AgenceActionsTypes {
  "LIST_AGENCE" = "LIST_AGENCE"
}

export enum AgenceMutationsTypes {
  "SET_AGENCE" = "SET_AGENCE"
}

export enum AgenceGettersTypes {
  "AGENCE_BY_ID" = "AGENCE_BY_ID",
  "AGENCE_ALL_ID" = "AGENCE_ALL_ID"
}
